<script lang="ts" setup>
const DEFAULT_IMG_SOURCE = '/avatar/0-default/default.png';

const props = withDefaults(
  defineProps<{
    imgPath?: string | null;
    width?: number;
    height?: number;
    quality?: number;
  }>(),
  {
    imgPath: DEFAULT_IMG_SOURCE,
    width: 160,
    height: 160,
    quality: 70,
  }
);

const imgPath = (props.imgPath ?? DEFAULT_IMG_SOURCE) as ImgixImagePath;

const { buildImgixURL } = useImgixURL();

const src = computed(() =>
  buildImgixURL(imgPath, {
    width: props.width,
    height: props.height,
    quality: props.quality,
    faceFit: true,
  })
);
</script>

<template>
  <span :class="$style.wrapper">
    <span :class="[$style.wrapper__content, $style.content]">
      <img
        :src="src"
        :class="[$style.content__thumbnail, $style['thumbnail']]"
      />
    </span>
  </span>
</template>

<style lang="scss" module>
.wrapper {
  display: inline-block;
}

.content {
  position: relative;
  display: inline-flex;
  isolation: isolate;

  &__icon {
    position: absolute;
    z-index: 1;
    width: 34%;
    bottom: -5%;
    right: 0%;
  }
}

.thumbnail {
  border-radius: 9999em;
  object-fit: contain;
}
</style>
